import type React from "react";
import { cn } from "../../lib/utils";
import { Icon, type IconProps } from "./icon";

export type SpinnerProps = Omit<IconProps, "name" | "as">;

/**
 * The loading glyph — the `loader` Icon spinning. Being an Icon, it takes the
 * semantic `size` tokens and `color` names, and always emits its own `size-*`
 * class. Defaults to `xl` (24px, the standalone/centered idiom); pass a
 * smaller token where it sits inline with text or controls.
 */
export function Spinner({
  className,
  size = "xl",
  ...props
}: SpinnerProps): React.ReactElement {
  return (
    <Icon
      aria-label="Loading"
      className={cn("animate-spin", className)}
      name="loader"
      role="status"
      size={size}
      {...props}
    />
  );
}
